import { Injectable } from "@angular/core";
import { BehaviorSubject, Observer, Subject, Subscription } from "rxjs";
import { ApiService } from "../services/api.service";
import { ApiServiceDelegate  } from "../models/api-service-delegate";
import { NzMessageService } from "ng-zorro-antd/message";
import { LoginComponent } from "../login/login.component";
import { ApiCollection } from "../providers/api-collection";
import { PriorityResponseModel, TaskCommentResponseModal, TaskResponseModel, TaskStatusResponseNodel,  UserGroupResponseModel,   UserResponseModel } from "../models/task.model";
import { HttpEventType, HttpResponse } from "@angular/common/http";
import { QuickAddService } from "../services/quick-add.service";
import { TasksComponent } from "../pages/tasks/tasks.component";
import { ProjectResponseModel } from "../models/project.model";
import { ClientAddress } from "../models/client.model";

@Injectable({
    providedIn: "root",
})

export class ConsoleViewModel {

    parentTasksComponent: TasksComponent;

    constructor(
        private apiService: ApiService,
        private message: NzMessageService,
        private quickAddService: QuickAddService
    ) { }

    errorService = new Subject()
    ClienttaskDataList = new BehaviorSubject<TaskResponseModel>(new TaskResponseModel())
    ProjecttaskDataList = new BehaviorSubject<TaskResponseModel>(new TaskResponseModel())
    projectListData = new BehaviorSubject<ProjectResponseModel>(new ProjectResponseModel())
    clientAddress = new BehaviorSubject<ClientAddress>(new ClientAddress())
    projectData = new Subject()
    taskData = new Subject()
    client = new Subject()


 getTaskList(page:number,page_size:number,data?:any,type?:string){
            let url = ApiCollection.Task +'?page='+page+'&page_size='+page_size;
             
            if(data && type){
                url += '&' + type + '=' + data.id
            }
            let d: ApiServiceDelegate = {
                Data: {},
                Method: "GET",
                Action: url,
               Success: (e: any) => {
                    type == 'client'  ? this.ClienttaskDataList.next(e) : this.ProjecttaskDataList.next(e);
                    return e;
                },
                Error: (e: String) => {
                    this.errorService.next(e)
                    return e;
                },
            };
            this.apiService.callService(d);
        }

        getTaskById(id:number){
            let d: ApiServiceDelegate = {
                Data: {},
                Method: "GET",
                Action:   ApiCollection.Task + '/'+id  ,
                Success: (e: any) => {
                   this.taskData.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                    return e;
                },
                Error: (e: String) => {
                    // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                    return e;
                },
            };
            this.apiService.callService(d);
        }

        getClientAddressId(id:number){
            let d: ApiServiceDelegate = {
                Data: {},
                Method: "GET",
                Action:   ApiCollection.Client_Address + '/'+id  ,
                Success: (e: any) => {
                   this.clientAddress.next(e)
                //    this.message.success("Tasks loaded successfully", {nzDuration: 1000});
                    return e;
                },
                Error: (e: String) => {
                    // this.message.success("Tasks loaded unsuccessfully", {nzDuration: 1000});
                    return e;
                },
            };
            this.apiService.callService(d);
        }

        getProjectList(page: number, page_size: number, data?:any,type?:string) {
            let url = ApiCollection.Project + '?page=' + page + '&page_size=' + page_size
            
            if(data && type){
                url += '&' + type + '=' + data.id
            }
            let d: ApiServiceDelegate = {
                Data: {},
                Method: "GET",
                Action:  url,
                Success: (e: any) => {
                    this.projectListData.next(e)
                    return e;
                },
                Error: (e: String) => {
                    this.message.error("Project loaded unsuccessfully", {nzDuration: 1000});
                    return e;
                },
            };
            this.apiService.callService(d);
        }


        getProjectById(id: number) {
            let d: ApiServiceDelegate = {
                Data: {},
                Method: "GET",
                Action: ApiCollection.Project + '/' + id,
                Success: (e: any) => {
                    this.projectData.next(e)
                    //    this.message.success("Project loaded successfully", {nzDuration: 1000});
                    return e;
                },
                Error: (e: String) => {
                    this.message.error("Project loaded unsuccessfully", {nzDuration: 1000});
                    return e;
                },
            };
            this.apiService.callService(d);
        }

        getClientByID( id: number) {
            let d: ApiServiceDelegate = {
                Data: {},
                Method: "GET",
                Action: ApiCollection.Client + '/' + id ,
                Success: (e: any) => {
                    this.client.next(e)
                    //    this.message.success("Client loaded successfully", {nzDuration: 1000});
                    return e;
                },
                Error: (e: String) => {
                    this.message.error("Client loaded unsuccessfully", {nzDuration: 1000});
                    return e;
                },
            };
            this.apiService.callService(d);
        }

    
    }